exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.base-calendar-page[data-v-a2ae4c08] {\n        margin-bottom: 63px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Frontend School (Prod)/ui/schools/src/components/main/pages/base/src/components/main/pages/base/BaseCalendar.vue"],"names":[],"mappings":";AAaA;QACA,oBAAA;CACA","file":"BaseCalendar.vue","sourcesContent":["<template>\n    <div class=\"base-calendar-page\">\n        <slot></slot>\n    </div>\n</template>\n\n<script>\n    export default {\n        name: 'BaseCalendar'\n    }\n</script>\n\n<style scoped>\n    .base-calendar-page {\n        margin-bottom: 63px;\n    }\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2ae4c08","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/pages/base/BaseCalendar.vue
// module id = DBWx
// module chunks = 0